<template>
  <div class="new-tool">
    <div @click="openApp" class="down">
      <div class="img"></div>
      <span>下载APP</span>
    </div>
    <!-- <div @click="openPlay" class="open" v-if="getCookie('type') == 2 || getCookie('type') == 9">
      <div class="img"></div>
      <span>开始直播</span>
    </div>
    <div @click="openPlay" class="open" v-else>
      <div class="img"></div>
      <span>申请开播</span>
    </div> -->
    <div @click="scrollTop" class="top">
      <div class="img"></div>
      <span>回到顶部</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FixedTool',
  data () {
    return {
      windowScrollTop: 0
    }
  },
  methods: {
    openPlay () {
      if (this.getCookie('type') == 2 || this.getCookie('type') == 9) {
        this.editmsg(4)
      } else {
        this.editmsg(2)
      }
    },
    openApp () {
      window.open('/app')
    },
    scrollTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    windowScroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this.windowScrollTop = scrollTop
    },
    initialize() {
      $(".loading input").val("");
      $(
        ".loading .get_message1, .loading .get_message2, .loading .get_message3, .get_message4"
      ).text("获取验证码");
      $(
        ".loading .get_message1, .loading .get_message2, .loading .get_message3, .get_message4"
      ).attr("isable", "able");
      $(
        ".loading .get_message1, .loading .get_message2, .loading .get_message3, .get_message4"
      ).removeClass("noevent");
      $("input[type='button']").val("登录");
    },
    pwloginFn() {
      this.initialize();
      $(".layui-layer-tips").remove();
      $(".loading_content1 .dongtai_btn.zhangHao").show();
      $(".loading_content1 .dongtai_btn.dongTai").hide();
      $(".loading").show();
      $(".loading_content1").show();
      $(".loading_content1 .loading_active").removeClass("loading_active");
      $(".loading_content1 .loading_title .zhanghao").addClass(
        "loading_active"
      );
      $(".loading_content1 .zhanghao_content").css("display", "block");
      $(".loading_content1 .forget").css("display", "block");
      $(".loading_content1 .dongtai_content").css("display", "none");
      $(".zhuce").show();
      $(".wx_login").show();
      $(".loading_content2").hide();
      $(".loading_content3").hide();
    },
    editmsg(type) {
      if (!this.getCookie("token")) {
        $(".before_login").show();
        $(".after_login").hide();
        this.pwloginFn();
        return;
      }
      if (type == 4) {
        location.href = "/anchor/";
        return;
      }
      $(".layui-layer-tips").remove();
      $("header + div>div").hide();
      this.exitshow = type;
      this.$emit("exitshow", type, true);
      if ($("#iframe2").length > 0) {
        if ($("#iframe2").attr("src")) {
          sessionStorage.setItem("iframe2", $("#iframe2").attr("src"));
          $("#iframe2").attr("src", "");
        }
      }
    }
  },
  // mounted(){
  //   window.addEventListener('scroll', this.windowScroll)
  // },
  // beforeDestroy () {
  //   window.removeEventListener('scroll', this.windowScroll)
  // }
}
</script>

<style lang="less" scoped>
.new-tool {
  position: fixed;
  right: 5%;
  bottom: 10%;
  width: 100px;
  background: #FFFFFF;
  border-radius: 4px 4px 4px 4px;
  padding: 18px;
  opacity: 1;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 10px 2px rgba(153,153,153,.1);
  min-height: auto !important;
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 12px;
    margin-bottom: 12px;
    cursor: pointer;
    border-bottom: 1px solid #F3F3F3;
    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 5px;
    }
    .img {
      width: 24px;
      height: 24px;
    }
    span {
      margin-top: 4px;
      font-size: 16px;
      line-height: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #3C485C;
    }
  }
  .down {
    .img {
      background-image: url('../assets/images/new/new-app-down.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &:hover {
      .img {
        background-image: url('../assets/images/new/new-app-down-red.png');
      }
      span {
        color: #C9353F;
      }
    }
  }
  .open {
    .img {
      background-image: url('../assets/images/new/open-play.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &:hover {
      .img {
        background-image: url('../assets/images/new/open-play-red.png');
      }
      span {
        color: #C9353F;
      }
    }
  }
  .top {
    .img {
      background-image: url('../assets/images/new/new-up.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    &:hover {
      .img {
        background-image: url('../assets/images/new/new-up-red.png');
      }
      span {
        color: #C9353F;
      }
    }
  }
}
</style>
